<table
  mat-table
  [dataSource]="forecastDateKpis"
  class="mat-elevation-z0 kpi-table"
  aria-hidden="true"
>
  <!-- Filter Name Column -->
  <ng-container matColumnDef="filterName">
    <th mat-header-cell *matHeaderCellDef class="title-bar">
      {{ 'RESULT.EXPLANATION.DATE_KPIS.TITLE_BAR.FILTER_NAME' | translate }}
    </th>
    <td mat-cell *matCellDef="let forecastDateKpi">
      <div class="flex">
        <div
          [inlineSVG]="'assets/layout/misc/dot.svg'"
          [ngStyle]="{ fill: forecastDateKpi.color }"
          class="dot"
        ></div>
        {{ forecastDateKpi.filterName }}
      </div>
    </td>
  </ng-container>

  <!-- Base Value Column -->
  <ng-container matColumnDef="basevalue">
    <th mat-header-cell *matHeaderCellDef class="title-bar">
      {{ 'RESULT.EXPLANATION.Y_FIELD._Baseline' | translate }}
    </th>
    <td mat-cell *matCellDef="let forecastDateKpi">
      @if (forecastDateKpi.baseValue) {
        {{ forecastDateKpi.baseValue | number: '1.2-2' }}
      }
    </td>
  </ng-container>

  <!-- Value Column -->
  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef class="title-bar">
      {{ 'RESULT.EXPLANATION.DATE_KPIS.TITLE_BAR.VALUE' | translate }}
    </th>
    <td mat-cell *matCellDef="let forecastDateKpi">
      @if (forecastDateKpi.value) {
        {{ forecastDateKpi.value | number: '1.2-2' }}
      }
    </td>
  </ng-container>

  <!-- Prediction Column -->
  <ng-container matColumnDef="prediction">
    <th mat-header-cell *matHeaderCellDef class="title-bar">
      {{ 'RESULT.EXPLANATION.DATE_KPIS.TITLE_BAR.PREDICTION' | translate }}
    </th>
    <td mat-cell *matCellDef="let forecastDateKpi">
      {{ forecastDateKpi.prediction | number: '1.2-2' }}
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="['filterName', 'basevalue', 'prediction', 'value']"
  ></tr>
  <tr
    mat-row
    *matRowDef="
      let row;
      columns: ['filterName', 'basevalue', 'prediction', 'value']
    "
  ></tr>
</table>
